jQuery3_4_1(document).ready(function($){
    function PlatformDisclaimerController(parent){
        var self = this;
        this.parent = parent;
        this.showCondition = jQuery3_4_1(parent).data("show-condition");
        this.storageID = "dd-disclaimer-closed-" + jQuery3_4_1(parent).data("post-id");

        this.handleClick = function(event, element){
            event.preventDefault();
            event.currentTarget.parentElement.parentElement.classList.add("ipe-do-fade");
            self.saveStateOnDevice();
            self.saveStateInSession();
        }
        this.addAction = function(index, element){
            jQuery3_4_1(element).on("click", (event)=>{self.handleClick(event, element)});
        }
        this.addActions = function(){
            jQuery3_4_1(self.parent).find(".dd-button").each(self.addAction);
        };
        this.reveal = function(){
            jQuery3_4_1(self.parent).removeClass("display-none")
        };
        this.saveStateOnDevice = function(){
            localStorage.setItem(self.storageID,"true");
        };
        this.saveStateInSession = function(){
            sessionStorage.setItem(self.storageID,"true");
        };
        this.checkDevice = function(){
            var deviceStatus = localStorage.getItem(self.storageID);
            if(deviceStatus == null) {
                return true;
            } else {
                return false;
            }
        };
        this.checkSession = function(){
            var sessionStatus = sessionStorage.getItem(self.storageID);
            if(sessionStatus == null) {
                return true;
            } else {
                return false;
            }
        };
        this.checkShowCondition = function(){
            switch (self.showCondition) {
                case 'never':
                    return false;
                case 'once-per-device':
                    return self.checkDevice();
                case 'once-per-session':
                    return self.checkSession();
                case 'always':
                    break;
                default:
                    break;
            }
            return true;
        };
        this.init = function(){
            jQuery3_4_1(document).ready(function(){
                var isEnabled = self.checkShowCondition();
                if(isEnabled) {
                    self.reveal();
                    self.addActions();
                }
            });
        };
        self.init();
    }


    registerOnLoadEvent(function(){
        $(".dd-disclaimer-controller").each(function(){
            new PlatformDisclaimerController(this);
        })
    });
});